import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('model-new-mobile-cta', {
    data() {
        return {
            showCta: false,
        };
    },

    computed: {
        showCtaHandler() {
            return this.showCta ? 'nav--visible' : '';
        },
        mobileCtaVisible() {
            return this.showCta ? 'model-new-mobile-cta-btn--visible' : '';
        },
        absoluteMobileCtaVisible() {
            return this.showCta ? '' : 'model-new-mobile-cta-btn--visible';
        },
    },

    watch: {
        showCta: function (visible) {
            EventBus.$emit('cta-state-changed', visible);
            if (!visible) {
                gsap.set(document.body, {
                    overflow: null,
                });
                return;
            }

            gsap.set(document.body, {
                overflow: 'hidden',
            });
        },
    },
});
